"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const RelinquishmentConfirmationPopup_1 = __importDefault(require("@Components/Popups/RelinquishmentConfirmationPopup"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const MlcTooltip_1 = __importDefault(require("@Components/MlcTooltip"));
const DisputeOptionItem_1 = __importDefault(require("@Components/OverclaimView/DisputeOptionSection/DisputeOptionItem"));
const react_sdk_1 = require("@openfeature/react-sdk");
const DisputeOptionSection = ({ onClickEmailOption, onClickAmendOption, isExistingRelinquishment, onClickUploadDocumentsOption, }) => {
    const [displayRelinquishPopup, setDisplayRelinquishPopup] = (0, react_1.useState)(false);
    const { value: showDocumentUpload } = (0, react_sdk_1.useFlag)('overclaim-document-upload', false);
    return (react_1.default.createElement("div", { className: 'overclaim-item-bottom-section' },
        react_1.default.createElement(ModalPortal_1.default, { isOpen: displayRelinquishPopup },
            react_1.default.createElement(RelinquishmentConfirmationPopup_1.default, { onClose: () => setDisplayRelinquishPopup(false) })),
        react_1.default.createElement("div", { className: 'overclaim-item-bottom-content' },
            react_1.default.createElement("h5", null, "You can choose to:"),
            react_1.default.createElement("div", { className: 'options-row' },
                react_1.default.createElement(DisputeOptionItem_1.default, { title: 'Option 1 - Email All Claimants', body: 'You can send an email to all claimants involved on this work to attempt to resolve the overclaim.', onClick: onClickEmailOption, buttonText: 'Email' }),
                react_1.default.createElement(DisputeOptionItem_1.default, { title: 'Option 2 - Amend Shares', body: 'Amend your shares on this work to an amount that makes the total shares equal 100% or less.', onClick: onClickAmendOption, buttonText: 'Amend Shares' }),
                react_1.default.createElement(MlcTooltip_1.default, { variant: 'info', place: 'top', id: 'relinquishment-disabled-tooltip' },
                    react_1.default.createElement("span", null, "You have already relinquished your shares for this overclaim. Please wait 1-2 days for processing.")),
                react_1.default.createElement(DisputeOptionItem_1.default, { title: 'Option 3 - Relinquish Shares', body: 'Relinquish all shares on this work.', onClick: () => setDisplayRelinquishPopup(true), buttonText: 'Relinquish Shares', dataTooltipId: isExistingRelinquishment ? 'relinquishment-disabled-tooltip' : undefined, disabled: isExistingRelinquishment }),
                showDocumentUpload && (react_1.default.createElement(DisputeOptionItem_1.default, { title: 'Option 4 - Upload Documents', body: 'Upload documents on this work to support your claim on this work.', onClick: onClickUploadDocumentsOption, buttonText: 'Upload Documents' }))))));
};
exports.default = DisputeOptionSection;
